import React from "react"

import { Container } from "./styled"

const Footer = props => {
  return (
    <>
      <Container>
        <footer className="text-gray-400 body-font">
          <div className="container py-8 mx-auto flex items-center sm:flex-row flex-col">
            <span  className="text-center ml-3 text-xl">Humberto Vasconcelos Faustino Porto<br/><br/><p>OAB/Go 54.075</p></span>
            <p className="text-center text-sm text-gray-400 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-800 sm:py-2 sm:mt-0 mt-4">
            <span  className="text-center ml-3 text-xl">William Santos Vieira<br/><br/><p>OAB/Go 73.290</p></span>
            </p>
          </div>
        </footer>
      </Container>
    </>
  )
}

export default Footer
